
export const calculateRisk = (email: string, domain: string, existingRequests: any[]) => {
  let score = 0;
  const signals = [];
  
  const personalDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com'];
  if (personalDomains.some(d => email.endsWith(d))) {
    score += 2;
    signals.push('Personal email domain used for enterprise request');
  }
  
  if (!domain || domain.trim() === '') {
    score += 2;
    signals.push('Missing company domain');
  }
  
  const duplicates = existingRequests.filter(r => r.companyDomain === domain);
  if (duplicates.length > 0) {
    score += 3;
    signals.push(`Duplicate domain detected (${duplicates.length} existing requests)`);
  }
  
  let level: 'Low' | 'Medium' | 'High' = 'Low';
  if (score >= 4) level = 'High';
  else if (score >= 2) level = 'Medium';
  
  return { score, signals, level };
};

export const cn = (...classes: (string | boolean | undefined)[]) => {
  return classes.filter(Boolean).join(' ');
};

export const formatTimeAgo = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};
